import { css } from 'styled-components';

import { MobileCartUpsellLocation } from '../types';

import { IContentProps, MobileAreaOptions, WebAreaOptions } from './types';

type AreaOptions = MobileAreaOptions | WebAreaOptions;

const insertItemIntoAreaOrder = <T extends AreaOptions>(
  areaOrder: T[],
  option: T,
  orderedItem: string
): T[] => {
  const position = areaOrder.indexOf(option);
  const mappedAreaOrder = [
    ...areaOrder.slice(0, position),
    orderedItem,
    ...areaOrder.slice(position),
  ];

  return mappedAreaOrder as T[];
};

export const mobileGridCSS = ({
  upsellEnabled,
  mobileCartUpsellLocation = MobileCartUpsellLocation.AboveYourCart,
  addOnEnabled,
}: IContentProps) => {
  // use this array as base for grid template area order
  let areaOrder = [MobileAreaOptions.DETAILS, MobileAreaOptions.CART, MobileAreaOptions.PAYMENT];

  /**
   * handle upsell enabled, 2 possible options:
   *  1. above cart
   *  2. above payment
   */
  if (upsellEnabled && mobileCartUpsellLocation === MobileCartUpsellLocation.AboveYourCart) {
    areaOrder = insertItemIntoAreaOrder(
      areaOrder,
      MobileAreaOptions.CART,
      MobileAreaOptions.UPSELL
    );
  } else if (
    upsellEnabled &&
    mobileCartUpsellLocation === MobileCartUpsellLocation.AbovePaymentDetails
  ) {
    areaOrder = insertItemIntoAreaOrder(
      areaOrder,
      MobileAreaOptions.PAYMENT,
      MobileAreaOptions.UPSELL
    );
  }

  if (addOnEnabled) {
    const optionMobile = upsellEnabled ? MobileAreaOptions.UPSELL : MobileAreaOptions.PAYMENT;
    areaOrder = insertItemIntoAreaOrder(areaOrder, optionMobile, MobileAreaOptions.ADDONS);
  }

  // create template areas in proper order
  const gridTemplateAreas = areaOrder.reduce((acc, cur) => {
    return `${acc}
    '${cur}'`;
  }, '');

  return css`
    grid-template-areas: ${gridTemplateAreas};
  `;
};

export const webGridCss = ({ upsellEnabled, addOnEnabled }: IContentProps) => {
  let areaOrder = [WebAreaOptions.DETAILS, WebAreaOptions.PAYMENT];

  // handle upsell enabled
  if (upsellEnabled) {
    areaOrder = insertItemIntoAreaOrder(areaOrder, WebAreaOptions.PAYMENT, WebAreaOptions.UPSELL);
  }

  if (addOnEnabled) {
    const option = upsellEnabled ? WebAreaOptions.UPSELL : WebAreaOptions.PAYMENT;
    areaOrder = insertItemIntoAreaOrder(areaOrder, option, WebAreaOptions.ADDONS);
  }

  // create template areas in proper order
  const gridTemplateAreas = areaOrder.reduce((acc, cur) => {
    return `${acc}
    '${cur}'`;
  }, '');

  return css`
    grid-template-areas: ${gridTemplateAreas};
  `;
};
